<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a id="page1"></a><a class="hlink" href="#/OEBPS/9780062029300_epub_toc_r1.htm#p01a">P a r t   O n e</a></h1>
<h1 class="subpart"><a class="hlink" href="#/OEBPS/9780062029300_epub_toc_r1.htm#p01a">GETTING THERE</a></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062029300_epub_p01_r1.vue?71cc869e